import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from './icons';
export const PainAgitation: React.FC = () => {
  const toxicFacts = ['High-heat processing creates toxic AGEs (Advanced Glycation End-products)', 'Leads to chronic, silent inflammation throughout the body', 'Accelerates joint pain and arthritis development', "Causes the heartbreaking 'gray muzzle' to appear years too early", 'Designed for maximum shelf-life, not optimal dog-life'];
  return <section className="py-20 px-6 sm:px-8 lg:px-12 max-w-5xl mx-auto border-t border-gold/30" data-id="element-214">
      <div className="text-center mb-12" data-id="element-215">
        <span className="text-xs font-bold tracking-[0.2em] text-gold uppercase block mb-4" data-id="element-216">
          Why The Industry Is Failing Us
        </span>
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-lg text-charcoal/80 leading-relaxed" data-id="element-218">
          <p data-id="element-219">
            You love your dog like a child. You buy the "Premium" kibble
            recommended by the TV ads. But every time you look at that dry,
            brown pellet, something feels off.
          </p>
          <p data-id="element-220">
            Deep down, you know that no living being can thrive on 100%
            processed food for a decade.
          </p>
          <p data-id="element-221">
            You feel guilty because you’re busy. You don't have hours to meal
            prep. But the cost of doing nothing is a shorter life for your best
            friend.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-8 rounded-xl shadow-lg border border-gold/20" data-id="element-222">
          <h3 className="font-serif text-2xl text-forest-dark mb-6 border-b border-gold/20 pb-4" data-id="element-223">
            What Big Pet Food Won't Tell You
          </h3>
          <ul className="space-y-4" data-id="element-224">
            {toxicFacts.map((fact, index) => <li key={index} className="flex items-start gap-3" data-id="element-225">
                <XIcon className="w-5 h-5 text-red-700 shrink-0 mt-0.5" data-id="element-226" />
                <span className="text-charcoal/80 text-sm sm:text-base" data-id="element-227">
                  {fact}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
};